import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  FinancialSnapshotLoadResult,
  FinancialSnapshotPatchBody,
  FinancialSnapshotPostBody,
  FinancialSnapshotResponse,
  FinancialSnapshotTemplate,
} from './financial-snapshot.model';

/**
 * Seam for Financial Snapshot API. Store + UI depend only on this token.
 * Mock (default) vs Http (follow-up story) are swapped via `provideFinancialSnapshot()`.
 */
export interface FinancialSnapshotApi {
  getTemplate(): Observable<FinancialSnapshotTemplate>;
  getSnapshot(guid: string): Observable<FinancialSnapshotLoadResult>;
  postSnapshot(body: FinancialSnapshotPostBody): Observable<FinancialSnapshotResponse>;
  patchCategory(guid: string, body: FinancialSnapshotPatchBody): Observable<FinancialSnapshotResponse>;
}

export const FINANCIAL_SNAPSHOT_API = new InjectionToken<FinancialSnapshotApi>('FINANCIAL_SNAPSHOT_API');
